import actionTypes from 'app/actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_THEME_SUCCESS: {
      return [...action.theme];
    }
    case actionTypes.UPDATE_THEME_COLOR_SUCCESS: {
      return state.map((color) => {
        if (color.id === action.color.id) {
          return {
            ...action.color,
          };
        }

        return color;
      });
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/theme/colors.js